import { Step } from 'semantic-ui-react';

export default Step;
